(function ($) {
    $(document).on('click', '.product-type-variable:not(.nyp-product) .single_add_to_cart_button', function (e) {
        e.preventDefault();

        var $thisbutton = $(this);
        var $form = $thisbutton.closest('form.cart')
        var id = $thisbutton.val();
        var product_qty = $form.find('input[name=quantity]').val() || 1;
        var product_id = $form.find('input[name=product_id]').val() || id;
        var variation_id = $form.find('input[name=variation_id]').val() || 0;

        var data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
			variation_id: variation_id,
        };

        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: function (response) {
                $thisbutton.removeClass('added').addClass('loading');
            },
            complete: function (response) {
                $thisbutton.addClass('added').removeClass('loading');
            },
            success: function (response) {

                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
                }
            },
        });

        return false;
    });
})(jQuery);

// keep stick image in containers
let stickyContainer = document.getElementById('sticky-container');
let stickyAbsolute = document.getElementById('sticky-absolute');

if (stickyContainer & stickyAbsolute) {

	let currentScreenWidth = window.innerWidth;
	if (currentScreenWidth > 1280) {
		let height = stickyContainer.offsetHeight;
		let width = stickyContainer.offsetWidth;
		let heightMinusMargins = height - 80;
		stickyAbsolute.style.height = heightMinusMargins +"px";
		stickyAbsolute.style.width = width +"px";
	} else {
		stickyAbsolute.style.height = "auto";
		stickyAbsolute.style.width = "auto";
	}
};
